import React from "react";

import * as styles from "./styles";

export function Loading() {
  return (
    <div className={styles.container} data-testid="score-poi-list-loading">
      <div className={styles.item} />
      <div className={styles.item} />
      <div className={styles.item} />
      <div className={styles.item} />
      <div className={styles.item} />
    </div>
  );
}
